export const nameValidRegex = "^[A-Za-z '-]+$";

export const passwordValidationRegex = /^(?=.*).{12,}$/;

export const dashboardUrl = '/dashboard';

export const customerRole = 'APIUser';

export const candidateRole = 'Candidate'; // Must be the same as BE Roles.Candidate.

export const refereeRole = 'Referee'; // Must be the same as BE Roles.Referee.

// Must be the same as referenceFormSpecCustomerRole in BE ReferenceFormSpecificationData.
export const referenceFormSpecCustomerRole = 'ReferenceFormSpecCustomerRole';

export const CandidateSubCustomerIdClaimName = 'SubCustomerId';

export const mobilePhoneMaxWidth = 599;

export const ukCountryCode = 'GBR';

export const auCountryCode = 'AUS';

export const nzlCountryCode = 'NZL';

export const irlCurrencyCode = 'IE';

export const irlCountryCode = 'IRL';

export const sgCountryCode = 'SGP';

export const caCountryCode = 'CAN';

export const usCountryCode = 'USA';

// Workflow type code
export const cust = 'CUST';

export const crim = 'CRIM';

export const icrm = 'ICRM';

export const icrd = 'ICRD';

export const scrm = 'SCRM'; // Slim CRIM (a mock Workflow).

export const vcrm = 'VCRM';

export const tcrm = 'TCRM';

export const idv = 'IDV';

export const pidv = 'PIDV';

export const ds = 'DS';

export const dbs = 'DBS';

export const anie = 'ANIE';

export const anis = 'ANIS';

export const std = 'STD';

export const enh = 'ENH';

export const vevo = 'VEVO';

export const ref = 'REF';

export const refPlus = 'REF+';

export const aml = 'AML';

export const advr = 'ADVR';

export const sanc = 'SANC';

export const pep = 'PEP';

// Mitek AML Search (Watchlist) check type codes.
export const mpep = 'MPEP';

export const msanc = 'MSANC';

export const madvr = 'MADVR';

export const maml = 'MAML';

export const nzmoj = 'NZMOJ';

export const auban = 'AUBAN';

export const aucom = 'AUCOM';

export const aucrd = 'AUCRD';

export const audir = 'AUDIR';

export const pvins = 'PVINS';

export const ecif = 'ECIF';

export const eid = 'EID';

export const pvnoi = 'PVNOI';

export const mcrd = 'MCRD';

export const mcid = 'MCID';

export const qual = 'QUAL';

export const pqal = 'PQAL';

export const uscr = 'USCR';

export const nzpv = 'NZPV';

// Child credit workflow type code
export const aubanc = 'AUBANC';

export const aucomc = 'AUCOMC';

export const aucrdc = 'AUCRDC';

export const audirc = 'AUDIRC';

export const eidc = 'EIDC';

export const ecifc = 'ECIFC';

export const pvnoic = 'PVNOIC';

export const pvinsc = 'PVINSC';

export const mcrdc = 'MCRDC';

export const mcidc = 'MCIDC';

// Child REF workflow type code
export const cref = 'CREF';

export const pref = 'PREF';

// Check type code
export const ccidv = 'CCIDV';

export const ukrtw = 'DRTW';

// Must match Pass.PhoenixWeb.FnApp Constants.EventLogDetailsTexts.UkviShareCodeProvidedPleaseVerify.
export const ukviShareCodeProvidedPleaseVerify = 'UKVI Share Code provided, please verify';

// Mitek service provider — use this to identify any mitek activity.
export const mitekServiceProvider = 'Mitek';
export const legacyMitekServiceProvider = 'Hooyu';
export const isMitekActivity = (serviceProvider: string | null | undefined) =>
	serviceProvider === mitekServiceProvider || serviceProvider === legacyMitekServiceProvider;

// Service request types used WITHIN mitek to differentiate between the three kinds of mitek check.
// Do not use these to detect "is this a mitek activity" — use isMitekActivity instead.
export const rtwServiceRequestType = 'RTW';
export const idvServiceRequestType = 'IDV';
export const crdServiceRequestType = 'CRD';

export const dbse = 'DBSE';

export const dbss = 'DBSS';

export const dbsev = 'DBSEV';

export const dbssv = 'DBSSV';

export const dbsa = 'DBSA';

export const ddbs = 'DDBS';

export const pdbs = 'PDBS';

export const dbsu = 'DBSU';

export const pstd = 'PSTD';

export const pstdv = 'PSTDV';

export const penh = 'PENH';

export const penhv = 'PENHV';

export const penha = 'PENHA';

export const DBSVolunteerEnhanced = 'DBSEV';

export const DBSVolunteerStandard = 'DBSSV';

export const DBSAdultFirstEnhanced = 'DBSA';

export const firstAdvantageChecks = [dbse, dbss, dbsev, dbssv, dbsa];

export const dbsChecks = [dbse, dbss, dbsev, dbssv, dbsa, dbs, enh, std];

export const acic = 'ACIC';

export const dco = 'DCO';

export const gidv = 'GIDV';

export const eidv = 'EIDV';

export const cidv = 'CIDV';

export const ccdvs = 'CCDVS';

export const idvPacificVevoCheckType = 'VEVO';

export const offr = 'OFFR';

export const disq = 'DISQ';

export const officersCheckActivityTypeCodes = [offr, disq];

export const dataCaptureActivityType = 'DataCapture';

export const addressValidationActivityTypeCode = 'ThirdParty';

export const addressValidationActivityType = 'CheckValidation';

export const thirdPartyCandidateDataCaptureActivityTypeCode = 'ThirdPartyCandidateDataCapture';

export const auResid = 'AURESID'; // for CRIM
// TODO: After the 1/8/2021 remove the usage of this constant and search for any duplicate strings of 'AUResidenceCheck' and remove them too.
export const auResidenceCheck = 'AUResidenceCheck'; // for IDV

export const auResidenceCheckTypes = [auResid, auResidenceCheck];

// The last activity type code is included for backwards compatibility with old Comply Advantage Workflows.
export const complyAdvantageActivityTypeCodes = [aml, advr, pep, sanc, 'Comply Advantage Check'];

// Mitek AML Search (Watchlist) check type codes (PEP / Sanctions / Adverse Media / combined AML).
export const mitekSearchActivityTypeCodes = [mpep, msanc, madvr, maml];

export const mitekCreditCheckActivityTypeCodes = [mcrd, mcid];

// Data capture service request type code
export const candidateDataCaptureServiceRequestTypeCode = 'CandidateDataCapture';

export const screenerDataCaptureServiceRequestTypeCode = 'ScreenerDataCapture';

export const screenerIdentityVerificationActivitySubtype = 'ScreenerIdentityVerification';

export const screenerConfirmIdentityActivitySubtype = 'ScreenerConfirmIdentity';

export const refDataCaptureCandidateActivitySubtype = 'RefDataCaptureCandidate';

// This message should be the same as the message in BE ValidateDataCaptureIsInProgress.
export const dataCaptureCompletedErrorMessage = 'Data capture process has been completed for this check.';

export const confirmIdentityAction = 'Confirm';

export const verifyIdentityAction = 'Verify';

export const idvPdfDocumentType = 'IDV - PDF Report'; // Must keep the same as BE IdvPdfDocumentType.

export const auParentCreditChecks = [auban, aucom, aucrd, audir];

export const auChildCreditChecks = [aubanc, aucomc, aucrdc, audirc];

export const ukParentCreditChecks = [pvins, pvnoi, eid, ecif, mcrd, mcid];

export const ukChildCreditChecks = Array.from(ukParentCreditChecks.map((t) => `${t}C`));

export const parentCreditChecks = auParentCreditChecks.concat(ukParentCreditChecks);

export const dateFormatString = 'dd MMM yyyy';

export const screeningReportFormatString = dateFormatString;

// Duplicated from DynamicFormConstants.cs.
export const ukPostCodeRegex =
	'^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2}[A-Za-z]{0,2})|([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$';

export const auPostCodeRegex = '^[0-9]{4}';

export const ukPostCodeRegexErrorMessage =
	'Please enter a valid postcode with a space after the district (e.g. SW1A 2AA).';

export const auPostCodeRegexErrorMessage = 'Please enter a valid postcode.';

export const organisationName = 'VETTING.com';

export const customChecks = [cust];

export const mitekPass = 'Candidate has the right to work in the UK based upon the evidence provided.';

export const candidateDeclinedConsent = 'Candidate declined to provide consent.';

export const mitekFail = `It has not been possible to confirm the Candidate's right to work in the UK based on the evidence
provided. You must try again with different documentation or complete the process manually.`;

export const notificationType = 'none';

export const ukCountry = 'United Kingdom';

export const fourHours = 1000 * 60 * 60 * 4;

export const scrubWorkflowsAfterSixMonths = [
	'DS',
	'ANI',
	'DBS',
	'ENH',
	'STD',
	'DBSA',
	'DBSE',
	'DBSS',
	'DBSEV',
	'DBSSV'
];

const currentDate = new Date();

export const sixMonthsAgo = new Date(currentDate.setMonth(currentDate.getMonth() - 6));

export const excludeWorkflows = ['CRIM', 'VCRM'];

export const reload = 'reload';

export const existingTabsOrWindows = 'tabsOpen';

export const oneDayInMilliseconds = 24 * 60 * 60 * 1000;

export const bullhorn = 'bullhorn';

export const jobAdder = 'jobadder';

export const smartRecruiters = 'smartrecruiters';

export const displayContents = 'displayContents=true';

export const shareCodeQuestion =
	'2. Please provide your share code from your UKVI account. This will allow us to check your right to work in the UK.';

export const hasOthernamesFieldname = 'customFields.hasOtherNames';

export const nameValidationMessage =
	'Please enter a valid name with alphabet characters, spaces, apostrophes and hyphens only.';

// EU countries for consent document logic
export const euCountries = [
	'AUT', // Austria
	'BEL', // Belgium
	'BGR', // Bulgaria
	'HRV', // Croatia
	'CYP', // Cyprus
	'CZE', // Czechia
	'DNK', // Denmark
	'EST', // Estonia
	'FIN', // Finland
	'FRA', // France
	'DEU', // Germany
	'GRC', // Greece
	'HUN', // Hungary
	'IRL', // Ireland
	'ITA', // Italy
	'LVA', // Latvia
	'LTU', // Lithuania
	'LUX', // Luxembourg
	'MLT', // Malta
	'NLD', // Netherlands
	'POL', // Poland
	'PRT', // Portugal
	'ROU', // Romania
	'SVK', // Slovakia
	'SVN', // Slovenia
	'ESP', // Spain
	'SWE' // Sweden
];

// Central American countries for regional consent
export const centralAmericanCountries = [
	'BLZ', // Belize
	'CRI', // Costa Rica
	'SLV', // El Salvador
	'GTM', // Guatemala
	'HND', // Honduras
	'NIC', // Nicaragua
	'PAN' // Panama
];

// South American countries for regional consent (excluding countries with specific consents)
export const southAmericanCountries = [
	'ARG', // Argentina
	'BOL', // Bolivia
	'CHL', // Chile
	'COL', // Colombia
	'ECU', // Ecuador
	'GUY', // Guyana
	'PRY', // Paraguay
	'PER', // Peru
	'SUR', // Suriname
	'URY', // Uruguay
	'VEN' // Venezuela
	// Note: Brazil (BRA) is excluded as it has its own specific consent
];
